import { useUser } from "../../../fetch/fetch.user.ts";
import ErrMessage from "../../core/ErrMessage.tsx";
import { EMPTY_USER_PROFILE } from "../../../const/typeDefault/User.ts";
import LoadingLine from "../../core/loading/LoadingLine.tsx";

const UserDescription = ({ userId }: { userId: string }) => {
  // State to store any data fetched asynchronously (if needed)
  const { user, isError, isLoading } = useUser(userId, EMPTY_USER_PROFILE);
  if (isLoading) {
    return (
      <section>
        <LoadingLine
          description={
            "lade... \n Ist es nicht spannend, was hier vielleicht stehen könnte? Warten wir noch kurz..."
          }
        />
      </section>
    );
  }
  if (isError) {
    return <ErrMessage message={isError.message} />;
  }
  if (user.description.length === 0)
    return "Hier könnte eine Beschreibung stehen.";
  return user.description;
};
export default UserDescription;
